import { Injectable } from '@angular/core';
import { GenericService, ErrorConfig } from './generic.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ServerResponse } from '../models/ServerResponse';
import { ElectricityPrice } from '../models/EnergyPrice';
import { UsersService } from './users.service';

@Injectable({
    providedIn: 'root'
})
export class ElectricityPricesService {
    constructor(private _httpService: GenericService, private _user: UsersService) {}

    getMarketElectricityPricesByDate(start: Date, end: Date, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<ElectricityPrice[]>> {
        let params = {}

        if (start && end) {
            params = {
                startDate: start.toDateString(),
                endDate: end.toDateString()
            }
        }
      
        return this._httpService.get(`${environment.apiUrl}ElectricityPrices/${this._user.userCountryCode}/MarketPrices`, true, params, undefined, errorConfig);
    }
      
      
      
}